export function resetFormFilters() {
    const formFilters = $('.form-filters');
    const form = formFilters.find('form');
    const selects = form.find('select');
    const resetBtn = formFilters.find('.button-clear');
    resetBtn.on('click', function (e) {
        e.preventDefault();

        form.find('input:text, textarea').val('');
        /*selects.each(function () {
            const select = $(this);
            const isMultiple = select.prop('multiple');

            if (isMultiple) {
                select.val([]).trigger('change');
            } else {
                select.prop("selectedIndex", 0);
            }
            jcf.replaceAll();
        })*/

        selects.each(function () {
            const select = $(this);
            const isMultiple = select.prop('multiple');

            if (isMultiple) {
                select.val([]).trigger('change');
            } else {
                select.prop("selectedIndex", 0).trigger('change');
            }
        });

        jcf.replaceAll();

    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/resetFormFilters.js